import { useMemo } from 'react';

export function useAppMode() {
  const appMode = useMemo(() => {
    const urlParams = new URL(window.location.href).searchParams;
    const appMode = urlParams.get('appMode');
    const cachedMode = localStorage.getItem('appMode');

    if (!appMode && cachedMode) return cachedMode;

    if (appMode === 'kiosk') {
      localStorage.setItem('appMode', 'kiosk');
    } else {
      localStorage.setItem('appMode', 'default');
    }

    return appMode;
  }, []);

  return appMode;
}
